//
//
//
//
//
//


export default {
  name: 'EmptyView',
}



// WEBPACK FOOTER //
// ./client/EmptyView.vue